{
  "version": 1,
  "asset_id": "1dee39d9-676a-46a5-bbf5-795aa9ccfbf4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/1dee39d9-676a-46a5-bbf5-795aa9ccfbf4/hiatal-type-1-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/1dee39d9-676a-46a5-bbf5-795aa9ccfbf4/hiatal-type-1-800.jpg",
  "original_filename": "hiatal-type-1-800.jpg",
  "size": 81345,
  "content_type": "image/jpeg",
  "created_at": "2026-09-24T19:21:22Z"
}
